import { createAction } from '@reduxjs/toolkit';
import { ActivitiesStaticImage } from 'types/content';

export const fetchActivitiesStaticImage = createAction('activitiesStaticImage/FETCH_ACTIVITIES_STATIC_IMAGE');
export const clearActivitiesStaticImage = createAction('activitiesStaticImage/CLEAR_ACTIVITIES_STATIC_IMAGE');
export const setActivitiesStaticImage = createAction<ActivitiesStaticImage>('activitiesStaticImage/SET_ACTIVITIES_STATIC_IMAGE');
